import { PreloadingStrategy, Route, Routes } from '@angular/router';
import { WelcomeComponent } from './welcome/welcome.component';
import { UnauthedGuard } from './common/guards/unauthed-guard';
import { UnauthedRedirectGuard } from './common/guards/unauthed-redirect-guard';
import { AuthedGuard } from './common/guards/authed.guard';
import { ImpersonateComponent } from './impersonate.component';
import { Injectable } from '@angular/core';
import { Observable, of as observableOf } from 'rxjs';
import { NicknameComponent } from './welcome-continue/nickname/nickname.component';
import { VerifyMfaComponent } from './welcome-continue/verify-mfa/verify-mfa.component';
import { WelcomeContinueComponent } from './welcome-continue/welcome-continue.component';
import { ActivateMfaComponent } from './welcome-continue/activate-mfa/activate-mfa.component';
import { LogoutComponent } from './common/components/logout/logout.component';
import { RedirectComponent } from './common/components/redirect/redirect.component';

export const routes: Routes = [
  { path: 'welcome', component: WelcomeComponent, canActivate: [UnauthedGuard] },
  {
    path: 'welcome-continue',
    component: WelcomeContinueComponent,
    canActivate: [UnauthedGuard],
    children: [
      // test partial pipeline, replace with MFA
      { path: 'nickname', component: NicknameComponent },
      { path: 'activate-mfa', component: ActivateMfaComponent },
      { path: 'verify-mfa', component: VerifyMfaComponent }
    ]
  },
  { path: 'forgot-password', component: WelcomeComponent, canActivate: [UnauthedGuard] },
  { path: 'new-password', component: WelcomeComponent, canActivate: [UnauthedRedirectGuard] },
  { path: 'invite', component: WelcomeComponent, canActivate: [UnauthedRedirectGuard] },
  {
    path: 'frontend',
    loadChildren: () => import('./frontend/frontend-routing.module').then((m) => m.routes),
    canActivate: [AuthedGuard],
    data: { preload: true }
  },
  {
    path: 'briefcase',
    loadChildren: () => import('./case-management/case-management-routing.module').then((m) => m.routes),
    data: { preload: true }
  },
  {
    path: 'guest/:qResponseId',
    loadChildren: () => import('./guest/guest-routing.module').then((m) => m.routes),
    data: { preload: false }
  },
  {
    path: 'version-info',
    loadChildren: () => import('./version-info/version-info-routing.module').then((m) => m.routes),
    data: { preload: false }
  },
  { path: 'impersonate', component: ImpersonateComponent },
  { path: 'logout', component: LogoutComponent },
  { path: '', component: RedirectComponent },
  { path: '**', redirectTo: 'welcome' }
];

@Injectable({
  providedIn: 'root'
})
export class MainPreloader implements PreloadingStrategy {
  preload(route: Route, preload: () => Observable<any>): Observable<any> {
    if (route.data && route.data['preload']) {
      return preload();
    } else {
      return observableOf(null);
    }
  }
}
